import debounce from 'lodash.debounce';
import { useCallback, useState } from 'react';
import { useDidUpdateEffect } from './useDidUpdateEffect';
import { useVariable } from './useVariable';
export var useDebounce = function useDebounce(value, delay) {
  if (delay === void 0) {
    delay = 100;
  }

  var _useState = useState(value),
      debouncedValue = _useState[0],
      setDebouncedValue = _useState[1];

  var updateDebouncedValue = useVariable(useCallback(debounce(function (newValue) {
    setDebouncedValue(newValue);
  }, delay), [delay]));
  useDidUpdateEffect(function () {
    updateDebouncedValue.current == null ? void 0 : updateDebouncedValue.current(value);
  }, [value]);
  return debouncedValue;
};